import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();
  return (
    <footer className="footer-mic">
      <Container>
        <Row className="footer-content">
          <Col md={3} sm={6} xs={12} className="footer-column">
            <div className="footer-logo">
              <div className="footer-logo-icon">
              <img 
                src="https://micgreen.com/img/LogoT.png" 
                alt="MIC Green Logo" 
                className="h-20 md:h-28 mx-auto animated-pulse"
              />
                  </div>
                  </div>
          
            
            <p className="footer-description">
              {t('footerDesc')}
            </p>
          </Col>
          <Col md={3} sm={6} xs={12} className="footer-column">
            <h5 className="footer-title">{t('aboutStore')}</h5>
            <ul className="footer-links">
              <li><Link to="/about">{t('aboutUs')}</Link></li>
              <li><Link to="/contact">{t('contactUs')}</Link></li>
              <li><Link to="/careers">{t('careers')}</Link></li>
              <li><Link to="/blog">{t('blog')}</Link></li>
            </ul>
          </Col>
          
          <Col md={3} sm={6} xs={12} className="footer-column">
            <h5 className="footer-title">{t('help')}</h5>
            <ul className="footer-links">
              <li><Link to="/help">{t('helpCenter')}</Link></li>
              <li><Link to="/shipping">{t('shippingDelivery')}</Link></li>
              <li><Link to="/returns">{t('returnsExchange')}</Link></li>
              <li><Link to="/faq">{t('faq')}</Link></li>
            </ul>
          </Col>
          
          <Col md={3} sm={6} xs={12} className="footer-column">
            <h5 className="footer-title">{t('legal')}</h5>
            <ul className="footer-links">
              <li><Link to="/privacy">{t('privacyPolicy')}</Link></li>
              <li><Link to="/terms">{t('termsConditions')}</Link></li>
              <li><Link to="/cookies">{t('cookiePolicy')}</Link></li>
              <li><Link to="/legal">{t('legalInfo')}</Link></li>
            </ul>
          </Col>
          
          <Col md={3} sm={6} xs={12} className="footer-column">
            <h5 className="footer-title">{t('followUs')}</h5>
            <div className="social-links">
              <a href="https://www.facebook.com/mic.green.735" target="_blank" rel="noreferrer" className="social-link" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.tiktok.com/@micgreen12?_r=1&_t=ZS-9371nNoc2HB" target="_blank" rel="noreferrer" className="social-link" aria-label="TikTok">
                <i className="fab fa-tiktok"></i>
              </a>
              <a href="https://www.instagram.com/micgreen2026/" target="_blank" rel="noreferrer" className="social-link" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://wa.me/249991160042" target="_blank" rel="noreferrer" className="social-link" aria-label="WhatsApp">
                <i className="fab fa-whatsapp"></i>
              </a>
              <a href="mailto:info@micgreen.com" target="_blank" rel="noreferrer" className="social-link" aria-label="Email">
                <i className="fas fa-envelope"></i>
              </a>
              <a href="https://www.youtube.com/@MIC_Green" target="_blank" rel="noreferrer" className="social-link" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
            <div className="newsletter">
              <h6>{t('subscribeNewsletter')}</h6>
              <div className="newsletter-form">
                <input type="email" placeholder={t('enterEmailPlaceholder') as string} />
                <button type="button">
                  <i className="fas fa-paper-plane"></i>
                </button>
              </div>
            </div>
            <div className="mt-3">
              <h6 className="mb-2">{t('language')}</h6>
              <div className="d-flex gap-2">
                <button 
                  type="button" 
                  className={`btn btn-sm ${language === 'en' ? 'btn-light' : 'btn-outline-light'}`} 
                  onClick={() => setLanguage('en')}
                >
                  {t('english')}
                </button>
                <button 
                  type="button" 
                  className={`btn btn-sm ${language === 'ar' ? 'btn-light' : 'btn-outline-light'}`} 
                  onClick={() => setLanguage('ar')}
                >
                  {t('arabic')}
                </button>
              </div>
            </div>
          </Col>
        </Row>
        
        <Row className="footer-bottom">
          <Col>
            <div className="footer-bottom-content">
              <p className="copyright">
                © {new Date().getFullYear()} MIC Green Store. {t('allRightsReserved')}
              </p>
              <div className="payment-methods">
                <span className="payment-label">{t('paymentMethodsAccepted')}</span>
                <i className="fab fa-cc-visa payment-icon"></i>
                <i className="fab fa-cc-mastercard payment-icon"></i>
                <i className="fab fa-cc-paypal payment-icon"></i>
                <i className="fas fa-money-bill-wave payment-icon"></i>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;

